module.exports = __webpack_public_path__ + "static/img/wxtp_20260714114138_95_157.11ec7af.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/news/20260714/wxtp_20260714114138_95_157.jpg
// module id = NgRa
// module chunks = 0